/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Badge_OptionalInputs */

const en_directory_submit_workspace_badge_optional = /** @type {(inputs: Directory_Submit_Workspace_Badge_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional enhancement`)
};

const zh_directory_submit_workspace_badge_optional = /** @type {(inputs: Directory_Submit_Workspace_Badge_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可选增强项`)
};

/**
* | output |
* | --- |
* | "Optional enhancement" |
*
* @param {Directory_Submit_Workspace_Badge_OptionalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_badge_optional = /** @type {((inputs?: Directory_Submit_Workspace_Badge_OptionalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Badge_OptionalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_badge_optional(inputs)
	return zh_directory_submit_workspace_badge_optional(inputs)
});
export { directory_submit_workspace_badge_optional as "directory.submit.workspace.badge_optional" }